//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import constant from '~/const';

export default {
  props: {
    value: { type: Boolean, default: false },
    data: { type: Object, default: () => ({}) },
    isCreating: { type: Boolean, default: false },
  },

  data() {
    return {
      create: {
        baseCurrency: '',
        quoteCurrency: '',
        coefficient: undefined,
        fixedValue: undefined,
        sources: [],
      },
      edit: {
        baseCurrency: '',
        quoteCurrency: '',
        coefficient: undefined,
        fixedValue: undefined,
        sources: [],
      },
      skip: null,
      take: null,
      isValueFixed: false,
      selectedSources: [],
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('tradersRates', {
      currencies: 'currencies',
      methods: 'paymentMethodsWithSources',
    }),

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    coefficient: {
      get() {
        if (!this.flow.coefficient) return undefined;
        const value = (this.flow.coefficient - 1) * 100;
        return value.toFixed(String(value).startsWith('0.') ? 1 : 0);
      },
      set(value) {
        this.flow.coefficient = value ? String((parseFloat(value) / 100) + 1) : undefined;
      },
    },

    flow() {
      return this.$props.isCreating ? this.create : this.edit;
    },

    isApplyPossible() {
      const hasDirection = this.flow?.sources.every((param) => param.direction);
      const hasSkip = this.flow?.sources.every((param) => !!param.skip && param.skip !== -1);
      const hasTake = this.flow?.sources.every((param) => !!param.take && param.take !== -1);

      return this.flow?.baseCurrency && this.flow?.quoteCurrency && (this.flow.sources.length > 0 || (this.isValueFixed && this.flow?.fixedValue)) && hasDirection && hasSkip && hasTake;
    },

    hasSources() {
      return this.flow.sources.length > 0;
    },
  },

  methods: {
    updateSources() {
      this.flow.sources = this.flow.sources.filter((s) => this.selectedSources.includes(s.type));

      this.selectedSources.forEach((source) => {
        if (!this.flow.sources.some((s) => s.type === source.id)) {
          this.flow.sources.push({
            type: source.id,
            caption: source.caption,
            disabled: source.disabled,
            direction: undefined,
            paymentMethods: [],
            skip: null,
            take: null,
          });
        }
      });
    },

    removeAllSources() {
      this.selectedSources = [];
      this.flow.sources = [];
    },

    getPaymentMethods(currency, exchanger) {
      return this.methods.filter((method) => {
        return method.currencyCode === currency && method.sourceType === exchanger;
      });
    },

    apply() {
      const payload = { ...this.flow };
      payload.sources = payload.sources.map((source) => {
        const newSource = { ...source };
        delete newSource.caption;
        delete newSource.disabled;

        if (newSource.minimalPaymentPeriod !== undefined) {
          newSource.minimalPaymentPeriod = Number(newSource.minimalPaymentPeriod);
        }

        if (newSource.paymentMethods?.length === 0) delete newSource.paymentMethods;

        if (this.$utils.getAppVersion() !== 2 && (!newSource.makerRoles || newSource.makerRoles.length === 0)) {
          delete newSource.makerRoles;
        }

        if (newSource.skip > 0 && newSource.take > 0) {
          newSource.skip = Math.max(0, newSource.skip - 1);
          newSource.take -= Math.max(0, newSource.skip - 1);
        } else {
          newSource.skip = undefined;
          newSource.take = undefined;
        }

        return newSource;
      });

      this.$emit('apply', payload);
    },

    handleFixedValueChange(value) {
      this.isValueFixed = value;
      if (value) {
        this.removeAllSources();
        this.flow.coefficient = undefined;
      } else {
        this.flow.fixedValue = undefined;
      }
    },
  },

  watch: {
    data: {
      handler(newData) {
        if (!this.isCreating && newData) {
          const edit = JSON.parse(JSON.stringify(newData));
          this.selectedSources = constant.rates.EXCHANGERS.filter((e) => edit.sources.some((s) => s.type === e.id));
          this.isValueFixed = !!edit.fixedValue;

          edit.sources = edit.sources.map((source) => ({
            ...source,
            skip: source.skip ? source.skip + 1 : null,
            take: source.take ? (source.take + source.skip) : null,
          }));

          this.edit = edit;
        }
      },
    },
    value: {
      handler(val) {
        if (val && this.isCreating) {
          this.selectedSources = [];
          this.flow = { ...this.create };
          this.removeAllSources();
          this.isValueFixed = false;
          this.flow.coefficient = undefined;
          this.flow.fixedValue = undefined;
        }
      },
    },
  },
};
